import { S, Icon } from '../regureStyles';

const ComplianceBanner = ({ auditedAt, allCompliant }) => {
  return (
    <div
      style={{
        background: allCompliant ? '#ecfdf5' : '#fef2f2',
        border: `1px solid ${allCompliant ? '#6ee7b7' : '#fca5a5'}`,
        borderRadius: 10,
        padding: '14px 20px',
        marginBottom: 28,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}
    >
      <Icon name={allCompliant ? 'check-circle' : 'alert-circle'} size={20} color={allCompliant ? S.success : S.danger} />
      <div>
        <span style={{ fontWeight: 600, color: allCompliant ? '#065f46' : '#991b1b', fontSize: 14 }}>
          {allCompliant ? 'All data residency requirements met' : 'Compliance review required'}
        </span>
        <span style={{ color: allCompliant ? '#047857' : '#b91c1c', fontSize: 13, marginLeft: 12 }}>
          100% of primary data resides in Switzerland — FADP &amp; FINMA compliant. Last verified: {auditedAt}.
        </span>
      </div>
    </div>
  );
};

export default ComplianceBanner;
